// 세션 도구 막대의 접속 정보(해상도 · FPS · 비트레이트 · RTT).
//
// 2026-10-12 사용자 요구:
//   ① 예전에는 원격 화면 왼쪽 위에 늘 겹쳐 그렸다(`.overlay`) — 상대 화면의 그 자리를 가리고 "원격 화면의 일부" 처럼 보였다.
//   ② 늘 보일 필요도 없다 — [⋯] 메뉴의 **[접속 정보 표시]** 를 켰을 때만 "연결됨" 옆에 한 줄로 그린다(기본 = 꺼짐).
// 켬/끔 상태는 세션 화면이 갖는다(`SessionView`) — 이 컴포넌트는 그리기만 한다.
//
// 막대 폭이 좁으면 CSS(`.bar-stats`)가 덜 중요한 항목(비트레이트 → 해상도)부터 숨긴다. 전체 값은 title 풍선에 있다.
import type { RtcStats } from '../rtc';

/** 통계 표본이 아직 없을 때(연결 직후) 보이는 글자. */
const STATS_PENDING = '연결 대기…';

export function SessionStats({ stats }: { stats: RtcStats | null | undefined }) {
  if (!stats) {
    return <span className="bar-stats pending">{STATS_PENDING}</span>;
  }
  const res = `${stats.width}×${stats.height}`;
  const fps = `${stats.fps} fps`;
  const kbps = `${stats.kbps} kbps`;
  const rtt = `RTT ${stats.rttMs} ms`;
  return (
    <span className="bar-stats" title={`접속 정보 — 해상도 ${res} · ${fps} · ${kbps} · ${rtt}`}>
      <span className="st-res">{res}</span>
      <span className="st-fps">{fps}</span>
      <span className="st-kbps">{kbps}</span>
      <span className="st-rtt">{rtt}</span>
    </span>
  );
}
